import Api from "@/repository/api";

import { IProductsUnitRepository } from '@/repository/warehouse/Unit/UnitRepository.types'
import { IProductsUnitItem, ProductsUnitResponse } from '@/entity/warehouse/Products/Unit/Unit.types'
import ProductsUnitTypes from "@/entity/warehouse/Products/Unit/Unit";

export class ProductsUnitRepository implements IProductsUnitRepository {
    async fetchAll(): Promise< IProductsUnitItem[]> {
        const response = await Api.get('/products/units/get');
        const responseData = response.data as ProductsUnitResponse[];
        return responseData.map((data: ProductsUnitResponse) => new ProductsUnitTypes(data));
    }
}